import fetch from '../config/fetch'

// 获取验证码信息
export const getCaptcha = () => fetch('/captcha', {
    token_validate: false,
})
// 获取验证码
export const mobileCode = phone => fetch('/verify_code', {
    token_validate: false,
    phone_number: phone,
}, 'GET');
// 登录
export const mobileLoginPost = (mobile, captcha, wxcode) => fetch('/mobile_login', {
    token_validate: false,
    mobile: mobile,
    code: captcha,
    wx_code: wxcode
}, 'POST');

export const passwdLoginPost = (mobile, passwd, captchaId, captcha, wxcode) => fetch('/passwd_login', {
    token_validate: false,
    mobile: mobile,
    password: passwd,
    captchaId: captchaId,
    captcha: captcha,
    wx_code: wxcode
}, 'POST')

export const wechatLogin = code => fetch('/qy_weixin_login', {
    token_validate: false,
    code: code
}, 'GET')

export const experienceLogin = () => fetch('/exp_login', { token_validate: false }, 'POST')

export const userList = data => fetch('/users', data)
export const userDetail = id => fetch(`/users/show/${id}`)
export const saleUserList = data => fetch('/users/sale', data)
export const userAreas = () => fetch('/users/areas')
export const dealerUsers = () => fetch('/users/dealer')
export const userListByAuthCode = data => fetch('/users/auth_code', data)
export const createUser = data => fetch('/users', data, 'POST')
export const updateUser = data => fetch(`/users/${data.id}`, data, 'PUT')
export const switchUserStatus = id => fetch(`/users/${id}/status`, {}, 'POST')
export const resetPassword = id => fetch(`/users/${id}/reset_pswd`, {}, 'POST')
export const updateUserDispatchArea = data => fetch(`/users/${data.id}/dispatch_area`, data, 'POST')
export const userLogout = () => fetch(`/users/0/logout`, {}, 'POST')

export const userSet = data => fetch(`/users/${data.id}/set`, data, 'POST')
export const userSwithAdmin = data => fetch(`/users/${data.id}/switch_admin`, data, 'POST')

export const groupList = data => fetch('/groups', data)
export const createGroup = data => fetch('/groups', data, 'POST')
export const updateGroup = data => fetch('/groups/' + data.id, data, 'PUT')
export const deleteGroup = id => fetch('/groups/' + id, {}, 'DELETE')
export const groupShow = id => fetch('/groups/' + id)

export const flowList = data => fetch('/flows', data)
export const createFlow = data => fetch('/flows', data, 'POST')
export const updateFlow = data => fetch('/flows/' + data.id, data, 'PUT')
export const deleteFlow = id => fetch('/flows/' + id, {}, 'DELETE')

export const itemCategoryList = data => fetch('/item_categories', data)
export const createItemCategory = data => fetch('/item_categories', data, 'POST')
export const updateItemCategory = data => fetch(`/item_categories/${data.id}`, data, 'PUT')
export const deleteItemCategory = id => fetch(`/item_categories/${id}`, {}, 'DELETE')

export const supplierList = data => fetch('/suppliers', data)
export const createSupplier = data => fetch('/suppliers', data, 'POST')
export const updateSupplier = data => fetch(`/suppliers/${data.id}`, data, 'PUT')
export const deleteSupplier = id => fetch('/suppliers/' + id, {}, 'DELETE')

export const stockroomList = data => fetch('/stockrooms', data)
export const createStockroom = data => fetch('/stockrooms', data, 'POST')
export const updateStockroom = data => fetch(`/stockrooms/${data.id}`, data, 'PUT')
export const deleteStockroom = id => fetch('/stockrooms/' + id, {}, "DELETE")

export const itemList = data => fetch('/items', data)
export const createItem = data => fetch('/items', data, 'POST')
export const updateItem = data => fetch('/items/' + data.id, data, 'PUT')
export const deleteItem = id => fetch('/items/' + id, {}, 'DELETE')
export const itemDetail = id => fetch('/items/' + id, {})
export const itemBatchDelete = data => fetch('/items/batch_delete', data, 'POST')

export const deviceList = data => fetch('/devices', data)
export const createDevice = data => fetch('/devices', data, 'POST')
export const updateDevice = data => fetch('/devices/' + data.id, data, 'PUT')
export const deleteDevice = id => fetch('/devices/' + id, {}, 'DELETE')
export const selectStoreItemList = data => fetch('/store_items/select', data)

export const stockInBillList = data => fetch('/stock_in_bills', data)
export const createStockInBill = data => fetch('/stock_in_bills', data, 'POST')
export const updateStockInBill = data => fetch(`/stock_in_bills/${data.id}`, data, 'PUT')
export const deleteStockInBill = id => fetch('/stock_in_bills/' + id, {}, 'DELETE')
export const stockInBillCheck = id => fetch('/stock_in_bills/' + id + '/check', {}, 'POST')

export const stockOutBillList = data => fetch('/stock_out_bills', data)
export const createStockOutBill = data => fetch('/stock_out_bills', data, 'POST')
export const updateStockOutBill = data => fetch(`/stock_out_bills/${data.id}`, data, 'PUT')
export const deleteStockOutBill = id => fetch('/stock_out_bills/' + id, {}, 'DELETE')
export const stockOutBillCheck = id => fetch('/stock_out_bills/' + id + '/check', {}, 'POST')

export const stockItemList = data => fetch('/store_items', data)
export const storeItemOutLogList = id => fetch(`/store_items/out_log/${id}`)

export const itemCostPrice = data => fetch('/item_cost_price', data, 'POST')
export const orderInfoFlow = data => fetch('/order_info_flow', data, 'POST')

export const createCustomer = data => fetch('/customers', data, 'POST')
export const updateCustomer = data => fetch('/customers', data, 'PUT')
export const changeCustomerRelation = data => fetch('/customers/relation', data, 'PUT')
export const changeCustomerDealer = data => fetch('/customers/dealer', data, 'PUT')
export const customerList = data => fetch('/customers', data)
export const customerDetail = id => fetch('/customers/detail/' + id, {})
export const customerInfo = id => fetch('/customers/info/' + id, {})
export const customerMaintainanceAmount = id => fetch('/customers/maintainance_amount/' + id, {})
export const deleteCustomer = data => fetch('/customers/delete', data, 'POST')
export const certificationCustomer = data => fetch('/customers/certification', data, 'POST')
export const updateCustomerParent = data => fetch('/customers/parent', data, 'POST')
export const recoveryCustomer = data => fetch('/customers/recovery', data, 'POST')
export const customerActiveList = data => fetch('/customers/active', data)
export const customerBatchTransfer = data => fetch('/customers/batch_transfer', data, 'POST')

export const createCustomerContact = data => fetch('/customer_contacts', data, 'POST')
export const updateCustomerContact = data => fetch('/customer_contacts', data, 'PUT')
export const customerContactList = data => fetch('/customer_contacts', data)
export const deleteCustomerContact = id => fetch('/customer_contacts/' + id, {}, 'DELETE')

export const createOrderCost = data => fetch('/order_costs', data, 'POST')
export const updateOrderCost = data => fetch('/order_costs', data, 'PUT')
export const deleteOrderCost = id => fetch('/order_costs/' + id, {}, 'DELETE')
export const orderCostList = data => fetch('/order_costs', data)
export const orderCostTypes = data => fetch('/order_costs/types', data)

export const createInvoiceRecord = data => fetch('/invoice_records', data, 'POST')
export const updateInvoiceRecord = data => fetch('/invoice_records', data, 'PUT')
export const deleteInvoiceRecord = id => fetch('/invoice_records/' + id, {}, 'DELETE')
export const invoiceRecordList = data => fetch('/invoice_records', data)

export const customerLogList = data => fetch('/customer_logs', data)
export const customerOrderLogList = data => fetch('/customer_order_logs', data)

export const customerExportRecordList = data => fetch('/file_export_records', data)

export const createCustomerFollowup = data => fetch('/customer_follow_ups', data, 'POST')
export const customerFollowupList = data => fetch('/customer_follow_ups', data)

export const createCustomerDevice = data => fetch('/customer_devices', data, 'POST')
export const mergeCustomerDevice = data => fetch('/customer_devices/merge', data, 'POST')
export const updateCustomerDevice = data => fetch('/customer_devices', data, 'PUT')
export const updateCustomerDeviceSapsync = data => fetch('/customer_devices/sap_sync', data, 'PUT')
export const updateCustomerDeviceRebind = data => fetch('/customer_devices/rebind', data, 'PUT')
export const customerDeviceList = data => fetch('/customer_devices', data)
export const customerDeviceExist = data => fetch('/customer_devices/find_exist', data)
export const customerDeviceGroupList = data => fetch('/customer_devices/group_list', data)
export const customerDeviceGroupDetail = data => fetch('/customer_devices/group_list/detail', data)
export const customerDeviceBatchUpdate = data => fetch('/customer_devices/batch_update', data, 'POST')
export const customerDeviceBatchTransfer = data => fetch('/customer_devices/batch_transfer', data, 'POST')
export const customerDeviceDetail = id => fetch('/customer_devices/detail/' + id)
export const customerDeviceDelete = data => fetch('/customer_devices/delete', data, 'POST')
export const customerDeviceMaintentance = data => fetch('/customer_devices/maintentance', data, 'POST')

export const customerDeviceDeliveryList = data => fetch('/customer_device_deliveries', data)

export const customerIssueList = data => fetch('/customer_issues', data)
export const createCustomerIssue = data => fetch('/customer_issues', data, 'POST')
export const updateCustomerIssue = data => fetch(`/customer_issues/${data.id}`, data, 'PUT')
export const deleteCustomerIssue = id => fetch(`/customer_issues/${id}`, {}, 'DELETE')
export const finishCustomerIssue = id => fetch(`/customer_issues/${id}/finish`, {}, 'POST')

export const customerDeviceAddressList = data => fetch('/customer_device_addresses', data)
export const createCustomerDeviceAddress = data => fetch('/customer_device_addresses', data, 'POST')
export const updateCustomerDeviceAddress = data => fetch('/customer_device_addresses', data, 'PUT')

export const customerUserList = data => fetch('/customer_users', data)
export const updateCustomerUser = data => fetch(`/customer_users/${data.id}`, data, 'PUT')

export const createContract = data => fetch('/contracts', data, 'POST')

export const createCustomerInvoice = data => fetch('/customer_invoices', data, 'POST')
export const updateCustomerInvoice = data => fetch('/customer_invoices', data, 'PUT')
export const customerInvoiceList = data => fetch('/customer_invoices', data)

export const createCustomerCollection = data => fetch('/customer_collections', data, 'POST')
export const updateCustomerCollection = data => fetch('/customer_collections', data, 'PUT')
export const customerCollectionList = data => fetch('/customer_collections', data)
export const deleteCustomerCollection = id => fetch('/customer_collections/' + id, {}, 'DELETE')

export const quotationList = data => fetch('/quotations', data)
export const createQuotaion = data => fetch('/quotations', data, 'POST')
export const quotationDetail = id => fetch('/quotations/' + id, {})
export const quotationVersionDetail = data => fetch('/quotations/' + data.id + '/version/' + data.vid, {})
export const updateQuotaion = data => fetch('/quotations/' + data.id, data, 'PUT')
export const updateQuotaionStatus = data => fetch('/quotations/' + data.id + '/status', data, 'PUT')
export const approveQuotation = data => fetch('/quotations/' + data.id + '/approve', data, 'PUT')
export const submitApproveQuotation = data => fetch('/quotations/' + data.quotation_id + '/approve/submit', data, 'PUT')
export const convertQuotation = id => fetch('/quotations/' + id + '/convert', {}, 'PUT')
export const deleteQuotation = id => fetch('/quotations/' + id, {}, 'DELETE')
export const recoveryQuotation = id => fetch('/quotations/' + id + '/recovery', {}, 'PUT')
export const exportQuotation = id => fetch('/quotations/' + id + '/export', {})

export const remarkTempList = data => fetch('/remark_temps', data)
export const createRemarkTemp = data => fetch('/remark_temps', data, 'POST')
export const updateRemarkTemp = data => fetch('/remark_temps/' + data.id, data, 'PUT')
export const deleteRemarkTemp = id => fetch('/remark_temps/' + id, {}, 'DELETE')

export const dealerList = data => fetch('/dealers', data)
export const dealerDetail = id => fetch('/dealers/' + id)
export const createDealer = data => fetch('/dealers', data, 'POST')
export const updateDealer = data => fetch(`/dealers/${data.id}`, data, 'PUT')
export const swtichDealerStatus = id => fetch(`/dealers/${id}/status`, {}, 'POST')
export const updateDealerUsage = data => fetch(`/dealers/${data.id}/usage`, data, 'PUT')
export const oemDealerList = data => fetch('/oem_dealers', data)
export const createDealerInvoice = data => fetch('/dealer_invoices', data, 'POST')

export const createDealerContact = data => fetch('/dealer_contacts', data, 'POST')
export const updateDealerContact = data => fetch('/dealer_contacts', data, 'PUT')
export const dealerContactList = data => fetch('/dealer_contacts', data)
export const deleteDealerContact = id => fetch('/dealer_contacts/' + id, {}, 'DELETE')

export const dealerInfo = () => fetch('/my_dealer')

export const dealerAdminTodoList = data => fetch('/todos/dealer', data)
export const saleTodoList = data => fetch('/todos/sale', data)

export const saleGoalDetail = data => fetch('/sale_goals', data)
export const saleGoalSet = data => fetch('/sale_goals/set', data, 'POST')

export const customerOrderDetail = id => fetch('/customer_orders/' + id, {})
export const customerOrderConfirm = data => fetch('/customer_orders/' + data.id + '/confirm', data, 'POST')
export const customerOrderList = data => fetch('/customer_orders', data)
export const createCustomerOrder = data => fetch('/customer_orders', data, 'POST')
export const updateCustomerOrder = data => fetch('/customer_orders/' + data.id, data, 'PUT')
export const deleteCustomerOrder = id => fetch('/customer_orders/' + id, {}, 'DELETE')
export const approveCustomerOrder = data => fetch('/customer_orders/' + data.id + '/approve', data, 'PUT')
export const submitApproveCustomerOrder = data => fetch('/customer_orders/' + data.customer_order_id + '/approve/submit', data, 'PUT')
export const recoveryCustomerOrder = id => fetch('/customer_orders/' + id + '/recovery', {}, 'PUT')
export const finishCustomerOrder = id => fetch('/customer_orders/' + id + '/finish', {}, 'PUT')
export const customerOrderContractExport = data => fetch('/customer_orders/' + data.id + '/contract', data)

export const purchaseOrderList = data => fetch('/purchase_orders', data)
export const createPurchaseOrder = data => fetch('/purchase_orders', data, 'POST')
export const purchaseOrderDetail = id => fetch('/purchase_orders/' + id)
export const updatePurchaseOrder = data => fetch('/purchase_orders/' + data.id, data, 'PUT')
export const deletePurchaseOrder = id => fetch('/purchase_orders/' + id, {}, 'DELETE')
export const purchaseOrderStatusChange = data => fetch('/purchase_orders/' + data.id + '/change_status', data, 'POST')

export const shippingRecordList = data => fetch('/shipping_records', data)
export const createShippingRecord = data => fetch('/shipping_records', data, 'POST')
export const updateShippingRecord = data => fetch('/shipping_records/' + data.id, data, 'PUT')
export const deleteShippingRecord = id => fetch('/shipping_records/' + id, {}, 'DELETE')

export const dashboardDataReport = data => fetch('/statistics/dashboard', data)
export const ongoinCount = () => fetch('/statistics/processing', {})
export const customerCoverage = data => fetch('/statistics/customer_coverage', data)
export const orderRate = data => fetch('/statistics/order_rate', data)
export const monthSales = data => fetch('/statistics/month_sales', data)
export const effectiveDeviceTotal = data => fetch('/statistics/effective_device/total', data)
export const effectiveDeviceSNDetail = data => fetch('/statistics/effective_device/sn_detail', data)
export const effectiveDeviceNamePlateDetail = data => fetch('/statistics/effective_device/name_plate_detail', data)


export const search = data => fetch('/search', data)
export const messageList = data => fetch('/messages', data)

export const fileExport = data => fetch('/files/export', data, data.method || 'GET')

export const qywxAuthLink = () => fetch('/qywx_auth_link', { token_validate: false })
export const serviceQuestShareDetail = uuid => fetch('/sq/' + uuid, { token_validate: false })

export const serviceQuestList = data => fetch('/service_quests/list', data, 'POST')
export const serviceQuestDetail = id => fetch('/service_quests/' + id, {})
export const createServiceQuest = data => fetch('/service_quests', data, 'POST')
export const updateServiceQuest = data => fetch('/service_quests/' + data.id, data, 'PUT')
export const updateServiceQuestNumber = data => fetch('/service_quests/' + data.id + '/number', data, 'PUT')
export const serviceQuestEvaluate = data => fetch('/service_quests/evaluate', data, 'POST')
export const serviceQuestDone = data => fetch('/service_quests/done', data, 'POST')
export const serviceQuestClose = data => fetch('/service_quests/close', data, 'POST')
export const serviceQuestDeliveryConfirm = data => fetch('/service_quests/delivery_confirm', data, 'POST')
export const serviceQuestSendCommentMsg = data => fetch('/service_quests/seng_comment_mgs', data, 'POST')
export const serviceQuestRollback = data => fetch('/service_quests/rollback', data, 'POST')
export const serviceQuestSetApproval = data => fetch('/service_quests/set_approval', data, 'POST')
export const serviceQuestApprove = data => fetch('/service_quests/approve', data, 'POST')
export const createServiceQuestResponse = data => fetch('/service_quest_responeses', data, 'POST')
export const serviceQuestRemind = () => fetch('/remind/service_quest', {})
export const serviceQuestGrab = data => fetch('/service_quests/grab', data, 'POST')
export const serviceQuestStatistics = data => fetch('/service_quests/statistics', data, 'POST')

export const serviceQuestCommentList = data => fetch('/service_quest_comments', data)

export const ccmCategoryList = data => fetch('/ccm_categories', data)
export const createCCMCategory = data => fetch('/ccm_categories', data, 'POST')
export const updateCCMCategory = data => fetch(`/ccm_categories/${data.id}`, data, 'PUT')
export const deleteCCMCategory = id => fetch(`/ccm_categories/${id}`, {}, 'DELETE')

export const serviceQuestFlowList = data => fetch('/service_quest_flows', data)
export const createServiceQuestFlow = data => fetch('/service_quest_flows', data, 'POST')
export const updateServiceQuestFlow = data => fetch(`/service_quest_flows/${data.id}`, data, 'PUT')
export const deleteServiceQuestFlow = id => fetch(`/service_quest_flows/${id}`, {}, 'DELETE')
export const serviceQuestFlowStatus = id => fetch(`/service_quest_flows/${id}/status`, {}, 'POST')
export const serviceQuestFlowCopy = id => fetch(`/service_quest_flows/${id}/copy`, {}, 'POST')

export const serviceQuestFlowStepList = data => fetch('/service_quest_flow_steps', data)
export const createServiceQuestFlowStep = data => fetch('/service_quest_flow_steps', data, 'POST')
export const updateServiceQuestFlowStep = data => fetch(`/service_quest_flow_steps/${data.id}`, data, 'PUT')
export const deleteServiceQuestFlowStep = id => fetch(`/service_quest_flow_steps/${id}`, {}, 'DELETE')

export const roleList = data => fetch('/roles', data)
export const createOrUpdateRole = data => fetch('/roles', data, 'POST')
export const deleteRole = id => fetch('/roles/' + id, {}, 'DELETE')
export const swtichRoleStatus = id => fetch('/roles/status/' + id, {}, 'POST')
export const authList = () => fetch('/auths')

export const resourceList = () => fetch('/resources')
export const setResource = data => fetch('/resources', data, 'POST')
export const userResourceList = data => fetch('/resources/user_resources', data)
export const userVisibleResourceList = data => fetch('/resources/user_visible_resources', data)
export const setUserResource = data => fetch('/resources/set', data, 'POST')

export const operationRecordList = data => fetch('/operation_records', data)

export const noticeList = data => fetch('/notices', data)
export const createNotice = data => fetch('/notices', data, 'POST')
export const updateNotice = data => fetch('/notices/' + data.id, data, 'PUT')
export const updateNoticeStatus = data => fetch('/notices/' + data.id + '/status', data, 'POST')
export const noticeApprove = data => fetch('/notices/' + data.id + '/approve', data, 'POST')
export const deleteNotice = id => fetch('/notices/' + id, {}, "DELETE")
export const noticeDetail = id => fetch('/notices/' + id)
export const noticeShow = id => fetch('/notices/' + id + '/show')

export const userNoticeList = data => fetch('/user_notices', data)
export const userNoticeDetail = id => fetch('/user_notices/detail/' + id)
export const userNoticeCategoryList = () => fetch('/user_notices/categories')

export const tagList = data => fetch('/tags', data)

export const repositoryList = data => fetch('/repositories', data)
export const createRepository = data => fetch('/repositories', data, 'POST')
export const updateRepository = data => fetch('/repositories/' + data.id, data, 'PUT')
export const updateRepositoryStatus = id => fetch('/repositories/' + id + '/status', {}, 'POST')
export const deleteRepository = id => fetch('/repositories/' + id, {}, "DELETE")
export const repositoryDetail = id => fetch('/repositories/' + id)

export const usedDeviceList = data => fetch('/used_devices', data)
export const createUsedDevice = data => fetch('/used_devices', data, 'POST')
export const updateUsedDevice = data => fetch('/used_devices/' + data.id, data, 'PUT')
export const deleteUsedDevice = id => fetch('/used_devices/' + id, {}, "DELETE")

export const deviceQuestList = data => fetch('/device_quests', data)
export const createDeviceQuest = data => fetch('/device_quests', data, 'POST')
export const updatedeviceQuest = data => fetch('/device_quests/' + data.id, data, 'PUT')
export const deviceQuestManage = data => fetch('/device_quests/' + data.id + "/manage", data, 'PUT')
export const deviceQuestHandle = data => fetch('/device_quests/' + data.id + "/handle", data, 'PUT')
export const deleteDeviceQuest = id => fetch('/device_quests/' + id, {}, "DELETE")

export const productPromotionList = data => fetch('/product_promotions', data)
export const createProductPromotion = data => fetch('/product_promotions', data, 'POST')
export const updateproductPromotion = data => fetch('/product_promotions/' + data.id, data, 'PUT')
export const changeProductPromotionStatus = data => fetch('/product_promotions/' + data.id + "/status", data, 'PUT')

export const sendSms = data => fetch('/sms/send', data, 'POST')
export const smsTemplates = () => fetch('/sms/templates', {}, 'GET')
export const smsRecords = data => fetch('/sms/records', data, 'GET')

// 商城商品管理
export const commodityList = data => fetch('/commodities', data)
export const commodityVersionList = data => fetch('/commodities/versions', data)
export const createCommodity = data => fetch('/commodities', data, 'POST')
export const updateCommodity = data => fetch('/commodities/' + data.id, data, 'PUT')
export const updateCommodityStatus = id => fetch('/commodities/' + id + '/status', {}, 'PUT')
export const deleteCommodity = id => fetch('/commodities/' + id, {}, "DELETE")

// 特殊价格
export const commodityPriceList = data => fetch('/commodity_prices', data)
export const deleteCommodityPrice = id => fetch('/commodity_prices/' + id, {}, "DELETE")


// 商城商品分类管理
export const commodityCategoryList = data => fetch('/commodity_categories', data)
export const createCommodityCategory = data => fetch('/commodity_categories', data, 'POST')
export const updateCommodityCategory = data => fetch('/commodity_categories/' + data.id, data, 'PUT')
export const updateCommodityCategoryStatus = id => fetch('/commodity_categories/' + id + '/status', {}, 'PUT')
export const deleteCommodityCategory = id => fetch('/commodity_categories/' + id, {}, "DELETE")

// 小程序Banner管理
export const bannerList = data => fetch('/banners', data)
export const createBanner = data => fetch('/banners', data, 'POST')
export const updateBanner = data => fetch('/banners/' + data.id, data, 'PUT')
export const updateBannerStatus = id => fetch('/banners/' + id + '/status', {}, 'PUT')
export const deleteBanner = id => fetch('/banners/' + id, {}, "DELETE")
export const topBanner = id => fetch('/banners/' + id + '/top', {}, 'PUT')

//商品PH与设备分类对照管理
export const commodityPhList = data => fetch('/commodity_phs', data)
export const createCommodityPh = data => fetch('/commodity_phs', data, 'POST')
export const updateCommodityPh = data => fetch('/commodity_phs/' + data.id, data, 'PUT')
export const deleteCommodityPh = id => fetch('/commodity_phs/' + id, {}, "DELETE")

//设备工艺管理
export const deviceCraftList = data => fetch('/customer_device_crafts', data)
export const deviceCraftPostList = data => fetch('/customer_device_crafts/list', data, 'POST')
export const createDeviceCraft = data => fetch('/customer_device_crafts', data, 'POST')
export const updateDeviceCraft = data => fetch('/customer_device_crafts/' + data.id, data, 'PUT')
export const deleteDeviceCraft = id => fetch('/customer_device_crafts/' + id, {}, "DELETE")

//自定义配置管理
export const getCustomConfig = data => fetch('/custom_configs', data)
export const createCustomConfig = data => fetch('/custom_configs', data, 'POST')

// 购物车
export const cartList = data => fetch('/carts', data)
export const createCart = data => fetch('/carts', data, 'POST')
export const updateCart = data => fetch('/carts/' + data.id, data, 'PUT')
export const deleteCart = data => fetch('/carts/delete', data, "POST")
export const changeCartStatus = data => fetch('/carts/status', data, "POST")

// 商城订单
export const commodityOrderList = data => fetch('/commodity_orders', data)
export const commodityOrderDetail = id => fetch('/commodity_orders/show/' + id, {})
export const commodityOrderConfirm = data => fetch('/commodity_orders/confirm', data)
export const commodityOrderPay = data => fetch('/commodity_orders/pay', data, 'POST')
export const commodityOrderApprove = data => fetch('/commodity_orders/approve', data, 'POST')
export const commodityOrderECApprove = data => fetch('/commodity_orders/ec_approve', data, 'POST')
export const commodityOrderFinish = data => fetch('/commodity_orders/finish', data, 'POST')
export const commodityOrderInit = data => fetch('/commodity_orders/init', data, 'POST')
export const createCommodityOrder = data => fetch('/commodity_orders', data, 'POST')
export const createCommodityOrderQuote = data => fetch('/commodity_orders/quote', data, 'POST')
export const updateCommodityOrder = data => fetch('/commodity_orders/' + data.id, data, 'PUT')
export const commodityOrderAddItem = data => fetch('/commodity_orders/add_item', data, 'POST')
export const updateCommodityOrderItem = data => fetch('/commodity_order_items/' + data.id, data, "PUT")
export const deleteCommodityOrderItem = id => fetch('/commodity_order_items/' + id, {}, "DELETE")
export const updateCommodityOrderStatus = data => fetch('/commodity_orders/' + data.id + '/status', data, 'PUT')
export const deleteCommodityOrder = id => fetch('/commodity_orders/' + id, {}, "DELETE")
export const commodityOrderContractExport = data => fetch('/commodity_orders/contract/' + data.id, data)
export const updateCommodityOrderDiscount = data => fetch('/commodity_orders/discount', data, 'POST')
export const approveCommodityOrderDiscount = data => fetch('/commodity_orders/discount_approve', data, 'POST')

export const commodityOrderFlowSetList = data => fetch('/flow_sets', data)
export const createCommodityOrderFlowSet = data => fetch('/flow_sets', data, 'POST')

// 商城地址
export const createAddress = data => fetch('/addresses', data, 'POST')
export const updateAddress = data => fetch('/addresses/' + data.id, data, 'PUT')

// 商城发票
export const createShoppingInvoice = data => fetch('/shopping_invoices', data, 'POST')
export const updateShoppingInvoice = data => fetch('/shopping_invoices/' + data.id, data, 'PUT')

// 中间商层级折扣管理
export const dealerStageDiscountList = () => fetch('/dealer_stage_discounts')
export const updateDealerStageDiscount = data => fetch('/dealer_stage_discounts', data, 'POST')

// 待审核事件
export const approveEventList = data => fetch('/approve_events', data)

//获取chinapay支付参数
export const getChinapayParams = data => fetch('/chinapay/pay_info', data)

// 公告分类管理
export const noticeCategoryList = data => fetch('/notice_categories', data)
export const createNoticeCategory = data => fetch('/notice_categories', data, 'POST')
export const updateNoticeCategory = data => fetch('/notice_categories/' + data.id, data, 'PUT')
export const updateNoticeCategoryStatus = id => fetch('/notice_categories/' + id + '/status', {}, 'PUT')
export const deleteNoticeCategory = id => fetch('/notice_categories/' + id, {}, "DELETE")

// 新品销售
export const newProductSaleList = data => fetch('/new_product_sales', data)
export const createNewProductSale = data => fetch('/new_product_sales', data, 'POST')

// 知识库
export const wikiList = data => fetch('/wikis', data)
export const createWiki = data => fetch('/wikis', data, 'POST')
export const updateWiki = data => fetch('/wikis/' + data.id, data, 'PUT')
export const updateWikiStatus = id => fetch('/wikis/' + id + '/status', {}, 'PUT')
export const deleteWiki = id => fetch('/wikis/' + id, {}, "DELETE")
export const wikiDetail = id => fetch('/wikis/' + id)

// 用户问答
export const wikiCommentList = data => fetch('/wiki_comments', data)
export const createWikiComment = data => fetch('/wiki_comments', data, 'POST')

//渠道二维码
export const qrcodeList = data => fetch('/qrcodes', data)
export const createQrcode = data => fetch('/qrcodes', data, 'POST')

//设备保养规则
export const maintainanceRuleList = data => fetch('/maintainance_rules', data)
export const createMaintainanceRule = data => fetch('/maintainance_rules', data, 'POST')
export const updateMaintainanceRule = data => fetch('/maintainance_rules/' + data.id, data, 'PUT')
export const updateMaintainanceRuletatus = id => fetch('/maintainance_rules/' + id + '/status', {}, 'PUT')
export const deleteMaintainanceRule = id => fetch('/maintainance_rules/' + id, {}, "DELETE")

export const campaignList = data => fetch('/campaigns', data)
export const updateCampaign = data => fetch('/campaigns/' + data.id, data, 'PUT')

export const leadsList = data => fetch('/leads', data)

export const serverDeploy = data => fetch('/server_deploy', data, 'POST')

export const getMPUrl = data => fetch('https://vts.leybold.cn/mp/api/v1/mp_url', data)